import Vue from 'vue'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import AppFilters from './filters/AppFilters'
import App from './views/App.vue'
import * as messaging from './helpers/messaging'
Vue.prototype.$messaging = messaging;

Vue.prototype.$store = store;
Vue.use(Vuetify);

//uj GA4 id: G-3WL0N9ESE3
//regi universal analytics id: UA-16956560-6
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: { id: "G-3WL0N9ESE3" }
});

for(let name in AppFilters.filters) {
    Vue.filter(name, AppFilters.filters[name]);
}

//502643773273375 pixel

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});

//google adsense
/*
import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense);
Vue.prototype.$adsende_client_id = 'ca-pub-9002345336032848';
*/
